module.exports = __webpack_public_path__ + "media/images/redesign-images/graduate-program/grad-03-698c48538b304021c91977570d8042eb.webp";